import { ZapposMagicLinkResponse } from "../api-types/zappos-api";
import { Mocker, makeMocker } from "./mock-common";

export const mockZapposMagicLinkResponse: Mocker<ZapposMagicLinkResponse> = makeMocker<ZapposMagicLinkResponse>({
  url: "http://www.zappos.com/zaw/amazon/magiclink?code=42069",
  partner: "amazon",
  customerId: "fIJGKX4Wppoi",
});
